export const BUSINESS = {
  name: "Iqaluit Cleaning & Maintenance",
  shortName: "ICM",
  phone: "+1 (867) 222-3259",
  phoneHref: "tel:+18672223259",
  email: "iqaluitcleaners@gmail.com",
  emailHref: "mailto:iqaluitcleaners@gmail.com",
  address: "902 Nunavut Dr, Iqaluit, Nunavut, X0A 0H0",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=902+Nunavut+Dr+Iqaluit+Nunavut+X0A+0H0",
  mapsEmbed:
    "https://www.google.com/maps?q=902+Nunavut+Dr+Iqaluit+Nunavut+X0A+0H0&output=embed",
  logo:
    "https://customer-assets.emergentagent.com/job_0c90bfe4-6a0f-4efc-8325-a5de2471ee83/artifacts/sv2s7dqp_image.png",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzcGFya2xpbmclMjBjbGVhbiUyMGhvdXNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgxNjM3NDAwfDA&ixlib=rb-4.1.0&q=85";

export const HERO_VIDEO = "https://assets.mixkit.co/videos/21380/21380-720.mp4";

// Rotating full-background hero clips: house detailing, surface sanitizing,
// upholstery deep clean and vacuuming — covering residential & commercial work.
export const HERO_VIDEOS = [
  "https://assets.mixkit.co/videos/21380/21380-720.mp4",
  "https://assets.mixkit.co/videos/5319/5319-720.mp4",
  "https://assets.mixkit.co/videos/34661/34661-720.mp4",
  "https://assets.mixkit.co/videos/45039/45039-720.mp4",
];

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb21tZXJjaWFsJTIwY2xlYW5lcnxlbnwwfHx8fDE3ODE2MzczODl8MA&ixlib=rb-4.1.0&q=85";

export const REVIEWS = [
  {
    name: "Sarah Aglukkaq",
    location: "Iqaluit, NU",
    rating: 5,
    text:
      "Absolutely spotless! The team did our move-out clean and we got our full deposit back. Punctual, friendly and incredibly thorough. Highly recommend to anyone in Iqaluit.",
  },
  {
    name: "David Pitsiulak",
    location: "Apex, NU",
    rating: 5,
    text:
      "We use ICM for our office every week. Professional, reliable and the building has never looked better. Great communication and flexible scheduling.",
  },
  {
    name: "Leah Joamie",
    location: "Iqaluit, NU",
    rating: 5,
    text:
      "Booked a move-in deep clean before we arrived. Walked into a fresh, sanitized home — kitchen and bathrooms sparkling. Worth every penny!",
  },
  {
    name: "Michael Tootoo",
    location: "Iqaluit, NU",
    rating: 5,
    text:
      "Best cleaning service in Nunavut, hands down. Detail-oriented and trustworthy. They handled our retail store after renovations and it was immaculate.",
  },
  {
    name: "Aaju Taqulik",
    location: "Iqaluit, NU",
    rating: 5,
    text:
      "Friendly local team that truly cares. They restocked our restrooms, cleaned every high-touch surface and left the breakroom shining. Will book again.",
  },
  {
    name: "Jennifer Okalik",
    location: "Iqaluit, NU",
    rating: 5,
    text:
      "Quick to respond and very professional. Our property management company relies on ICM between tenants. Consistent, high-quality results every time.",
  },
];

export const SERVICES = [
  {
    id: "commercial",
    title: "Commercial Cleaning",
    tagline: "Clean, professional & healthy work environments.",
    blurb:
      "Customized cleaning solutions for businesses and commercial facilities, scheduled daily, weekly, or monthly.",
    features: [
      "Office cleaning and sanitization",
      "Dusting and surface disinfection",
      "Vacuuming and mopping floors",
      "Restroom cleaning and restocking",
      "Breakroom and kitchen cleaning",
      "Garbage and recycling removal",
      "Window and glass cleaning",
      "High-touch surface disinfection",
      "Floor care and maintenance",
      "Scheduled daily, weekly, or monthly cleaning",
    ],
    idealFor: [
      "Offices",
      "Retail stores",
      "Government buildings",
      "Medical clinics",
      "Schools & community facilities",
      "Industrial spaces",
    ],
  },
  {
    id: "move-in",
    title: "Residential Move-In Cleaning",
    tagline: "Move into a fresh, sanitized home.",
    blurb:
      "A detailed cleaning service designed to prepare a home for new occupants before moving in.",
    features: [
      "Deep cleaning of kitchens and bathrooms",
      "Appliance cleaning (inside and outside)",
      "Cabinet and drawer cleaning",
      "Dusting of walls, baseboards, and trim",
      "Vacuuming and mopping all floors",
      "Window sill and interior glass cleaning",
      "Sanitizing high-touch surfaces",
      "Removal of dust and debris left by previous occupants",
    ],
    idealFor: [
      "New homeowners",
      "Families relocating to Iqaluit",
      "Tenants moving in",
      "Anyone wanting a move-in ready home",
    ],
  },
  {
    id: "move-out",
    title: "Residential Move-Out Cleaning",
    tagline: "Inspection & sale ready, every time.",
    blurb:
      "A comprehensive cleaning service to prepare properties for inspection, sale, or new tenants.",
    features: [
      "Deep cleaning of all rooms",
      "Kitchen degreasing and sanitization",
      "Bathroom descaling and disinfecting",
      "Cleaning inside cabinets, closets, and drawers",
      "Baseboard and trim cleaning",
      "Floor vacuuming and washing",
      "Spot cleaning walls and doors",
      "Interior window cleaning",
      "Removal of garbage and leftover debris",
    ],
    idealFor: [
      "Homeowners selling a property",
      "Tenants recovering security deposits",
      "Landlords preparing units",
      "Property managers between occupancies",
    ],
  },
];

export const SERVICE_OPTIONS = [
  "Commercial Cleaning",
  "Residential Move-In Cleaning",
  "Residential Move-Out Cleaning",
  "Recurring / Scheduled Cleaning",
  "Other / Not Sure",
];

export const WHY_CHOOSE = [
  {
    title: "Local & Dependable",
    text:
      "Proudly based in Iqaluit, serving homeowners, businesses and property managers across Nunavut.",
  },
  {
    title: "Attention to Detail",
    text:
      "Every corner, baseboard and high-touch surface — we don't cut corners, we clean them.",
  },
  {
    title: "Flexible Scheduling",
    text:
      "Daily, weekly, monthly or one-time deep cleans that fit around your life and your business.",
  },
  {
    title: "Residential & Commercial",
    text:
      "From move-in/move-out homes to offices and clinics, we have the expertise for any space.",
  },
  {
    title: "Quality & Satisfaction",
    text:
      "We build lasting relationships through integrity, reliability and exceptional customer service.",
  },
  {
    title: "Trusted Solutions",
    text:
      "Cleaning plans tailored to your needs, delivered by a professional team you can count on.",
  },
];

export const GALLERY = [
  {
    src:
      "https://customer-assets.emergentagent.com/job_0c90bfe4-6a0f-4efc-8325-a5de2471ee83/artifacts/m0zduma5_WhatsApp%20Image%202026-06-15%20at%2011.03.04%20%281%29.jpeg",
    label: "Living Room Deep Clean — Iqaluit",
  },
  {
    src:
      "https://customer-assets.emergentagent.com/job_0c90bfe4-6a0f-4efc-8325-a5de2471ee83/artifacts/h8ij6afg_WhatsApp%20Image%202026-06-15%20at%2011.05.05%20%281%29.jpeg",
    label: "Kitchen Deep Clean — Before",
  },
  {
    src:
      "https://customer-assets.emergentagent.com/job_0c90bfe4-6a0f-4efc-8325-a5de2471ee83/artifacts/rouh4d2b_WhatsApp%20Image%202026-06-15%20at%2011.05.06%20%281%29.jpeg",
    label: "Kitchen Deep Clean — After",
  },
];

export const SERVICE_AREAS = [
  "Iqaluit",
  "Apex",
  "Niaqunngut",
  "Tundra Valley",
  "Lower Base",
  "Happy Valley",
  "Road to Nowhere",
  "Surrounding Nunavut communities",
];
